import React, { Component, Fragment } from "react";
import DesignDetailsEditorModal from "./DesignDetailsEditorModal";
import { pmaActions } from "_store/_actions";
import { connect } from "react-redux";

class DesignDetails extends Component {
  state = {
    editQuadrantFormData: null,
    oldQuadrantData: [],
    selectedQuadrantNumber: null,
    titleEdit: false,
    maxMainTitleLength: 45,
    filteredAreas: {},

    savingMessageShowing: false,
  };

  handleFormClose = () => {
    const { editQuadrantFormData, oldQuadrantData } = this.state;
    const restoredQuadrantData = oldQuadrantData.find(
      (quadrant) => quadrant.ddAreaID === editQuadrantFormData?.ddAreaID,
    );

    this.props.updateDesignDetailsSpecificModalOpen(false);
    this.setState({
      editQuadrantFormData: restoredQuadrantData
        ? { ...restoredQuadrantData }
        : editQuadrantFormData,
      selectedQuadrantNumber: null,
      titleEdit: false,
      savingMessageShowing: false,
    });
  };
  onEditFormSubmit = () => {
    const { editQuadrantFormData, oldQuadrantData } = this.state;
    const updatedQuadrantData = { ...editQuadrantFormData };
    const updatedOldQuadrantData = oldQuadrantData.map((quadrant) =>
      quadrant.ddAreaID === updatedQuadrantData.ddAreaID
        ? { ...updatedQuadrantData }
        : quadrant,
    );
    this.props.setDesignDetailsInfoForAgent(updatedOldQuadrantData);
    this.setState({
      oldQuadrantData: updatedOldQuadrantData,
      editQuadrantFormData: updatedQuadrantData,
      savingMessageShowing: true,
    });
    setInterval(() => {
      this.setState({ savingMessageShowing: false });
    }, 5000);
  };
  openSelectedQuadrant = (quadrantNumber, titleEdit) => {
    this.props.updateDesignDetailsSpecificModalOpen(true);
    this.setState({
      selectedQuadrantNumber: quadrantNumber,
      titleEdit: titleEdit,
      savingMessageShowing: false,
    });
  };
  componentDidMount = () => {
    if (this.props.printVersion) {
      require("./print.scss");
    } else {
      require("./editor.scss");
    }

    const { currentArea, designDetailsInfoList } = this.props;

    const quadrantSource = Array.isArray(designDetailsInfoList)
      ? designDetailsInfoList
      : [];

    this.props.updateDesignDetailsSpecificModalOpen(false);
    let newObj = [...quadrantSource]
      .filter((quadrantObj) => quadrantObj.ddAreaID === currentArea.mlsAreaID)
      .map((i) => ({ ...i }))[0];

    if (!newObj && currentArea.mlsAreaID.includes("DEMO")) {
      newObj = quadrantSource[0];
    }

    this.setState({
      oldQuadrantData: [...quadrantSource].map((i) => ({ ...i })),
      editQuadrantFormData: [...quadrantSource]
        .filter((quadrantObj) => quadrantObj.ddAreaID === currentArea.mlsAreaID)
        .map((i) => ({ ...i }))[0],
    });
  };
  handleRestoreDefault = () => {
    const {
      selectedQuadrantNumber,
      editQuadrantFormData,
      oldQuadrantData,
      titleEdit,
    } = this.state;
    if (titleEdit) {
      this.setState({
        // mainTitle: oldTitle,
      });
    } else if (selectedQuadrantNumber >= 0) {
      let newObj = [...editQuadrantFormData].map((i) => ({ ...i }));
      let oldSelection = [...oldQuadrantData].map((i) => ({
        ...i,
      }))[selectedQuadrantNumber];
      newObj[selectedQuadrantNumber].text = oldSelection.text;
      this.setState({
        editQuadrantFormData: newObj,
      });
    }
  };
  handleInputChange = (e) => {
    const { editQuadrantFormData } = this.state;
    const target = e.target;
    const value = target.value;
    const name = target.name;
    const clonedEditQuadrantFormData = {
      ...editQuadrantFormData,
      [name]: value,
    };
    this.setState({
      editQuadrantFormData: clonedEditQuadrantFormData,
    });
  };
  applyToAllAreas = () => {
    console.log("applyToAllAreas");
  };

  render() {
    const {
      mlsAreas,
      designDetailsSpecificModalOpen,
      currentArea,
      printVersion,
      fromEditor,
      agentData,
      showAllEditButtons,
    } = this.props;

    const { openSelectedQuadrant, handleInputChange, handleRestoreDefault } =
      this;
    const {
      editQuadrantFormData,
      oldQuadrantData,
      selectedQuadrantNumber,
      titleEdit,
      maxMainTitleLength,
      savingMessageShowing,
    } = this.state;
    const { listgenUserID } = agentData;

    let quadrantStyles;
    // let showButtons = false;
    let designDetailsImage =
      "https://d2onbxnrte2nim.cloudfront.net/non-covers/081926_BackCover_Backgound_1.png";
    if (listgenUserID === "101006") {
      designDetailsImage =
        "https://d2onbxnrte2nim.cloudfront.net/non-covers/050826_JoeRamos_BackCvr_ImageONLY-2.png";

      quadrantStyles = "dd-regular-section-spacing";
    } else if (listgenUserID === "116941") {
      designDetailsImage =
        "https://d2onbxnrte2nim.cloudfront.net/non-covers/050926_DesignDetails_BackCvr_3-120ppi.png";
    }
    let showButtons = fromEditor && showAllEditButtons;
    //let showButtons = false;
    let isSueRubin = agentData.listgenUserID === "110067";
    let sueRubinFooter = (
      <div className="design-details-quadrant-qr">
        <p>Tips for positioning your</p>
        <p>home for today’s market.</p>
      </div>
    );
    let showFooter = true;

    if (editQuadrantFormData && Object.keys(editQuadrantFormData).length >= 1) {
      const {
        dd1Title,
        dd1Text,
        dd2Title,
        dd2Text,
        dd3Title,
        dd3Text,
        dd4Title,
        dd4Text,
      } = editQuadrantFormData;

      return (
        <Fragment>
          {editQuadrantFormData &&
            Object.keys(editQuadrantFormData).length >= 1 &&
            designDetailsSpecificModalOpen && (
              <div className="design-details-editor-modal-scope">
                <DesignDetailsEditorModal
                  oldQuadrantData={oldQuadrantData}
                  onCloseFn={this.handleFormClose}
                  handleInputChange={handleInputChange}
                  editQuadrantFormData={editQuadrantFormData}
                  onEditFormSubmit={this.onEditFormSubmit}
                  selectedQuadrantNumber={selectedQuadrantNumber}
                  handleRestoreDefault={handleRestoreDefault}
                  titleEdit={titleEdit}
                  mlsAreas={mlsAreas}
                  maxMainTitleLength={maxMainTitleLength}
                  savingMessageShowing={savingMessageShowing}
                />
              </div>
            )}
          <div
            className={`${
              printVersion
                ? "print-april-2023-design-details-container"
                : "editor-april-2023-design-details-container"
            } ${quadrantStyles && quadrantStyles} `}
          >
            <div className="design-details-quadrant">
              <div className="design-details-quadrant-body">
                {fromEditor &&
                  showButtons &&
                  !designDetailsSpecificModalOpen && (
                    <div>
                      <div
                        className="design-details-quadrant-btn design-details-quadrant-btn-1"
                        onClick={() => openSelectedQuadrant(1)}
                      >
                        <div>Edit this section</div>
                      </div>
                      <div
                        className="design-details-quadrant-btn design-details-quadrant-btn-2"
                        onClick={() => openSelectedQuadrant(2)}
                      >
                        <div>Edit this section</div>
                      </div>
                      <div
                        className="design-details-quadrant-btn design-details-quadrant-btn-3"
                        onClick={() => openSelectedQuadrant(3)}
                      >
                        <div>Edit this section</div>
                      </div>
                      <div
                        className="design-details-quadrant-btn design-details-quadrant-btn-4"
                        onClick={() => openSelectedQuadrant(4)}
                      >
                        <div>Edit this section</div>
                      </div>
                    </div>
                  )}
                <div className="design-details-section-container">
                  <div className="design-details-section-image-container">
                    <img
                      src={designDetailsImage}
                      alt=""
                      className="design-details-section-placeholder-img"
                    />
                  </div>
                  <div className="design-details-section-row">
                    <div
                      className={`${
                        1 === selectedQuadrantNumber &&
                        "design-details-selected-quadrant-section"
                      } design-details-quadrant-section design-details-section-1`}
                      // onClick={() => openSelectedQuadrant(1)}
                      key={1}
                    >
                      <div className="design-details-quadrant-section-title">
                        <p dangerouslySetInnerHTML={{ __html: dd1Title }}></p>
                      </div>
                      <div
                        className="design-details-quadrant-section-text"
                        dangerouslySetInnerHTML={{ __html: dd1Text }}
                      ></div>
                    </div>
                    <div
                      className={`${
                        2 === selectedQuadrantNumber &&
                        "design-details-selected-quadrant-section"
                      } design-details-quadrant-section design-details-section-2`}
                      // onClick={() => openSelectedQuadrant(2)}
                      key={2}
                    >
                      <div className="design-details-quadrant-section-title">
                        <p dangerouslySetInnerHTML={{ __html: dd2Title }}></p>
                      </div>
                      <div
                        className="design-details-quadrant-section-text"
                        dangerouslySetInnerHTML={{ __html: dd2Text }}
                      ></div>
                    </div>
                    <div
                      className={`${
                        3 === selectedQuadrantNumber &&
                        "design-details-selected-quadrant-section"
                      } design-details-quadrant-section design-details-section-3`}
                      // onClick={() => openSelectedQuadrant(3)}
                      key={3}
                    >
                      <div className="design-details-quadrant-section-title">
                        <p dangerouslySetInnerHTML={{ __html: dd3Title }}></p>
                      </div>
                      <div
                        className="design-details-quadrant-section-text"
                        dangerouslySetInnerHTML={{ __html: dd3Text }}
                      ></div>
                    </div>
                    <div
                      className={`${
                        4 === selectedQuadrantNumber &&
                        "design-details-selected-quadrant-section"
                      } design-details-quadrant-section design-details-section-4`}
                      key={4}
                    >
                      <div className="design-details-quadrant-section-title">
                        <p dangerouslySetInnerHTML={{ __html: dd4Title }}></p>
                      </div>
                      <div
                        className="design-details-quadrant-section-text"
                        dangerouslySetInnerHTML={{ __html: dd4Text }}
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Fragment>
      );
    } else {
      return <div></div>;
    }
  }
}

const mapStateToProps = (state) => {
  return {
    designDetailsSpecificModalOpen: state.pma.designDetailsSpecificModalOpen,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateDesignDetailsSpecificModalOpen: (isModalOpen) => {
      dispatch(pmaActions.updateDesignDetailsSpecificModalOpen(isModalOpen));
    },
    setDesignDetailsInfoForAgent: (designDetailsInfoList) => {
      dispatch(pmaActions.setDesignDetailsInfoForAgent(designDetailsInfoList));
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(DesignDetails);
